import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import TransactionList from "../../components/screen/purchaseOnlinePbf/TransactionList";

const PurchaseListTransactionPbfPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <TransactionList />
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gray"}
      noPadding={true}
    />
  );
};

export default HOC(PurchaseListTransactionPbfPage);
